// AuthContext.js
import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

let userData = {};
const user_info = localStorage.getItem("user_info");
if (user_info) {
  userData = JSON.parse(user_info);
}

export const AuthProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState(userData);

  const collection = {
    userInfo,
    setUserInfo,
  };

  return (
    <AuthContext.Provider value={collection}>{children}</AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
